import { Fragment } from 'react';
import HideOnWebview from '../webview/HideOnWebview';
import Footer from './footer';
import Header from './header';

const Layout = ({
  children,
  header = { type: 'main' },
  footer = { type: 'main' },
  hideLayout,
}: LayoutProps) => {
  if (hideLayout) {
    return <main id='main'>{children}</main>;
  }

  return (
    <Fragment>
      <HideOnWebview>
        <Header settings={header} />
      </HideOnWebview>
      <main id='main'>{children}</main>
      <HideOnWebview>
        <Footer settings={footer} />
      </HideOnWebview>
    </Fragment>
  );
};

export default Layout;
